<template>
  <div class="container">
    <div class="button-last-registration-container">
      <ion-list class="selector">
        <ion-item>
          <ion-select
            aria-label="CheckIn Type"
            interface="popover"
            :placeholder="checkInTypes.length ? 'Select CheckIn Type' : 'No types available'"
            v-model="selectedCheckInType"
            :disabled="!checkInTypes.length"
          >
            <ion-select-option
              v-for="option in checkInTypes"
              :key="option.id"
              :value="option.type"
            >
              {{ option.type }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
      <ion-button shape="round" color="primary" @click="handleCheckIn">
        CHECK IN
      </ion-button>
      <check-in-out-last-registration />
    </div>
  </div>
</template>

<script>
import { IonButton, IonItem, IonList, IonSelect, IonSelectOption } from "@ionic/vue";
import { defineComponent, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import CheckInOutLastRegistration from "./CheckInOutLastRegistration.vue";
import ApiService from "../../common/service.api";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    IonButton,
    CheckInOutLastRegistration,
    IonList,
    IonItem,
    IonSelect,
    IonSelectOption,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const isLoading = ref(false);
    const checkInTypes = ref([]); 
    const selectedCheckInType = ref(null);   
    const idElement = ref(null);

    const fetchData = async () => {
      try {
        const route = useRoute();
        const { id } = route.params;
        console.log('id chkin', id)
        console.log('parametro chekin', route.params)
        const journeyResponse = await ApiService.get(`Journey/Get/${id}`);
        console.log('journey checking campaign' ,journeyResponse)
        idElement.value = journeyResponse.data[0]?.children[0].idElement;
        if (!idElement.value) {
          console.error("idElement not found");
          return;
        }
        const checkInOutResponse = await ApiService.get(`CheckInOut/Get/${idElement.value}`);

        const typesWithId1 = checkInOutResponse.data.idsType.filter((item) => item.id === 1);
        checkInTypes.value = typesWithId1;
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    const handleCheckIn = async () => {
      const campaignId = route.params.id;
      isLoading.value = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: store.getters["user/getUserData"].id,
        idType: 1,
        type: selectedCheckInType.value,
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
        checkin: true,
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);

        router.push(`/campaign-journey/${campaignId}/check-out`);
      } catch (error) {
        console.error("Error al registrar el Check In:", error);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchData();
    });

    return {
      handleCheckIn,
      isLoading,
      checkInTypes,
      selectedCheckInType,
    };
  },
});
</script>

<style scoped>
.button-last-registration-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.selector {
  margin-top: 20px;
}
</style>
